function checkResolution() {
    const size = window.screen.width;

    if ( size === 768 ) {
        setTimeout(() => 
            document.querySelector(".sk-progress-bar").dataset.fixed = false,
            500 
        );
    }
};

export { checkResolution };